// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/* eslint-disable @typescript-eslint/no-explicit-any */
import { getChatSelector } from "../../../../../chat-component-bindings/src";
import { useHandlers } from './useHandlers';
import { useAdaptedSelector } from './useAdaptedSelector';
/**
 * @private
 */
export const usePropsFor = (component) => {
    const selector = getChatSelector(component);
    if (!selector) {
        throw new Error("Can't find the selector for component, please check supported component list");
    }
    return Object.assign(Object.assign({}, useAdaptedSelector(selector)), useHandlers(component));
};
//# sourceMappingURL=usePropsFor.js.map